<template>
	<div class="step-resort">
		<PageHeader :title="store.state.home?.title ?? ''" />

		<div class="pb-8 px-4.5">
			<div class="flex flex-col gap-3">
				<template v-if="store.state.resorts && store.state.resorts.length > 0">
					<RouterLinkButton
						v-for="(resort) in store.state.resorts"
						:key="resort.ref"
						:to="
              ! resort.available_in_active_locale
              ? resort.pre_reservation_flow_url
              : { name: 'resort-date', params: { resort: resort.ref, date: store.state.arrivalDate }}
            "
						class="flex items-center py-2 px-4 min-h-20 bg-white rounded-lg shadow gap-4 text-left w-full overflow-hidden"
					>
						<img :src="resort.logo" :alt="resort.ref" class="flex-none w-10 h-10" />
						<span class="flex flex-col flex-1 gap-1">
							<span class="inline-block font-serif sm:text-xl">{{ resort.title }}</span>
							<span v-if="! resort.available_in_active_locale" class="text-neutral-500">
								{{ t('unavailable_in_active_locale_message') }}
							</span>
						</span>
						<span
							class="flex items-center justify-center flex-none w-8 h-8 rounded-full bg-neutral-50 text-neutral-500 border border-neutral-100"
						>
							<IconChevronRight class="h-3" />
						</span>
					</RouterLinkButton>
				</template>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import PageHeader from '../components/PageHeader.vue';
import useStore from '../store';
import RouterLinkButton from '../components/RouterLinkButton.vue';
import IconChevronRight from '@thermenresorts/icons/svg/chevron-right.svg';

const { t } = useI18n();
const store = useStore();
</script>
